import React, { useState, useEffect } from 'react';
import {
  getAllTemplates,
  saveCustomTemplate,
  updateTemplate,
  deleteTemplate,
  templateToForm,
  emptyTemplateForm,
  isCustomTemplate,
} from '../../common/templateStore';
import { inputStyle, cardStyle, formBoxStyle } from './adminShared';

function AdminTemplates() {
  const [templates, setTemplates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(emptyTemplateForm);
  const [previewUrl, setPreviewUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    refreshTemplates();
  }, []);

  async function refreshTemplates() {
    try {
      setLoading(true);
      setError('');
      setTemplates(await getAllTemplates());
    } catch (err) {
      setError(err.message || 'Şablonlar yüklenemedi.');
    } finally {
      setLoading(false);
    }
  }

  function resetForm() {
    setForm(emptyTemplateForm);
    setEditingId(null);
    setPreviewUrl('');
    setShowForm(false);
  }

  function openCreateForm() {
    setEditingId(null);
    setForm(emptyTemplateForm);
    setPreviewUrl('');
    setShowForm(true);
  }

  function openEditForm(item) {
    setEditingId(item.id);
    setForm(templateToForm(item));
    setPreviewUrl(item.coverImg || '');
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (name === 'coverImg') setPreviewUrl(value);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.title || !form.url) return;

    try {
      setError('');
      if (editingId) {
        await updateTemplate(editingId, form);
      } else {
        await saveCustomTemplate(form);
      }
      resetForm();
      await refreshTemplates();
    } catch (err) {
      setError(err.message || 'Kayıt işlemi başarısız.');
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Bu şablonu silmek istediğinize emin misiniz?')) return;
    try {
      setError('');
      await deleteTemplate(id);
      if (editingId === id) resetForm();
      await refreshTemplates();
    } catch (err) {
      setError(err.message || 'Silme işlemi başarısız.');
    }
  }

  const customCount = templates.filter((t) => isCustomTemplate(t.id)).length;

  return (
    <>
      <div className="sec-head mb-50">
        <div className="d-flex align-items-center flex-wrap">
          <div>
            <span className="sub-title main-color mb-5">Yönetim Paneli</span>
            <h3 className="fw-600 fz-40">Şablon Yönetimi</h3>
          </div>
          <div className="ml-auto d-flex align-items-center flex-wrap" style={{ gap: '12px' }}>
            <a href="/sablonlar" className="butn butn-sm butn-bord radius-30">
              <span>Şablonları Görüntüle</span>
            </a>
            <button
              onClick={() => (showForm && !editingId ? resetForm() : openCreateForm())}
              className="butn butn-sm butn-bg main-colorbg radius-5"
              style={{ border: 'none', cursor: 'pointer' }}
            >
              <span className="text">
                {showForm && !editingId ? 'Formu Kapat' : '+ Yeni Şablon'}
              </span>
            </button>
          </div>
        </div>
        <p className="p-color mt-15 fz-14">
          Toplam {templates.length} şablon ({customCount} admin tarafından eklendi)
        </p>
        {error && <p className="main-color mt-15 fz-14">{error}</p>}
        {loading && <p className="p-color mt-15 fz-14">Yükleniyor...</p>}
      </div>

      {showForm && (
        <div className="mb-60 p-40" style={formBoxStyle}>
          <div className="d-flex align-items-center mb-30">
            <h5 className="mb-0">
              {editingId ? 'Şablonu Düzenle' : 'Yeni Şablon Ekle'}
            </h5>
            {editingId && (
              <button
                type="button"
                onClick={resetForm}
                className="ml-auto p-color fz-14"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Düzenlemeyi İptal Et
              </button>
            )}
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row lg-marg">
              <div className="col-lg-6">
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Şablon Adı *</label>
                  <input
                    type="text"
                    name="title"
                    value={form.title}
                    onChange={handleChange}
                    placeholder="Şablon başlığı"
                    required
                    style={inputStyle}
                  />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Kategori</label>
                  <input
                    type="text"
                    name="category"
                    value={form.category}
                    onChange={handleChange}
                    placeholder="ör: Ajans, E-Ticaret, Portfolyo"
                    style={inputStyle}
                  />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Demo URL *</label>
                  <input
                    type="url"
                    name="url"
                    value={form.url}
                    onChange={handleChange}
                    placeholder="https://..."
                    required
                    style={inputStyle}
                  />
                </div>
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Kısa Açıklama</label>
                  <textarea
                    name="desc"
                    value={form.desc}
                    onChange={handleChange}
                    placeholder="Şablon hakkında kısa açıklama..."
                    rows={3}
                    style={{ ...inputStyle, resize: 'vertical' }}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-20">
                  <label className="sub-title fz-12 mb-10 d-block">Kapak Resmi URL</label>
                  <input
                    type="text"
                    name="coverImg"
                    value={form.coverImg}
                    onChange={handleChange}
                    placeholder="https://... veya /assets/imgs/..."
                    style={inputStyle}
                  />
                </div>
                {previewUrl ? (
                  <div
                    style={{
                      borderRadius: '8px',
                      overflow: 'hidden',
                      maxHeight: '200px',
                      border: '1px solid rgba(255,255,255,0.1)',
                    }}
                  >
                    <img
                      src={previewUrl}
                      alt="Önizleme"
                      style={{ width: '100%', objectFit: 'cover' }}
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      borderRadius: '8px',
                      border: '1px dashed rgba(255,255,255,0.2)',
                      height: '200px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'rgba(255,255,255,0.3)',
                      fontSize: '14px',
                    }}
                  >
                    Resim önizlemesi burada görünecek
                  </div>
                )}
              </div>
            </div>
            <div className="mt-30 d-flex align-items-center" style={{ gap: '12px' }}>
              <button
                type="submit"
                className="butn butn-sm butn-bg main-colorbg radius-5"
                style={{ border: 'none', cursor: 'pointer' }}
              >
                <span className="text">{editingId ? 'Güncelle' : 'Şablonu Ekle'}</span>
              </button>
              {editingId && (
                <button
                  type="button"
                  onClick={resetForm}
                  className="butn butn-sm butn-bord radius-30"
                  style={{ border: 'none', cursor: 'pointer' }}
                >
                  <span>İptal</span>
                </button>
              )}
            </div>
          </form>
        </div>
      )}

      <div className="row lg-marg">
        {templates.map((item) => (
          <div key={item.id} className="col-lg-4 col-md-6 mb-40">
            <div style={cardStyle}>
              {item.coverImg && (
                <div style={{ height: '160px', overflow: 'hidden' }}>
                  <img
                    src={item.coverImg}
                    alt=""
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
              )}
              <div style={{ padding: '20px' }}>
                <span className="sub-title main-color fz-12">{item.category}</span>
                <h6 className="mt-10 mb-10">{item.title}</h6>
                <p className="p-color fz-13 mb-10">{item.desc?.slice(0, 80)}...</p>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-color fz-12 d-block mb-20"
                  style={{ wordBreak: 'break-all' }}
                >
                  {item.url}
                </a>
                <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="butn butn-sm butn-bord radius-30"
                  >
                    <span>Demoya Git</span>
                  </a>
                  <button
                    onClick={() => openEditForm(item)}
                    className="butn butn-sm butn-bord radius-30"
                    style={{ border: 'none', cursor: 'pointer' }}
                  >
                    <span>Düzenle</span>
                  </button>
                  <button
                    onClick={() => handleDelete(item.id)}
                    className="butn butn-sm radius-30"
                    style={{
                      border: '1px solid rgba(255,80,80,0.4)',
                      color: '#ff6b6b',
                      background: 'transparent',
                      cursor: 'pointer',
                    }}
                  >
                    <span>Sil</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default AdminTemplates;
